import React, { useState } from 'react';
import './App.css';
import './styles/app.css';
import { Nav } from "./components/nav/nav";
import { Routes, Route } from "react-router-dom";
import WelcomePage from "./components/pages/WelcomePage";
import MathTrainerHome from "./components/pages/Home";
import MathStart from "./components/pages/math/MathStart";
import AdditionPage from "./components/pages/math/AdditionPage";
import SubtractionPage from "./components/pages/math/SubtractionPage";
import MultiplicationPage from "./components/pages/math/MultiplicationPage";
import DivisionPage from "./components/pages/math/DivisionPage";



function App() {
    // "linear-gradient(to bottom right, #fef9c3, #fbcfe8)",
    // "linear-gradient(to bottom right, #1f2937, #1e3a8a)",
    const [loggedIn, setLoggedIn] = useState(true);
    return (
        <div className="flex items-center justify-between w-full" style={{
            background: "linear-gradient(to bottom right, #1f2937, #1e3a8a)",
            color: "white", }}>
            <div className="flex items-center justify-between w-full">
                <Nav>
                    <Routes>
                        <Route path="/" index element={<WelcomePage />} />
                        <Route path="home" element={<MathTrainerHome />} />
                        <Route path="math" element={<MathStart />}>
                        </Route>
                        <Route path="math/addition" element={<AdditionPage />} />
                        <Route path="math/subtraction" element={<SubtractionPage />} />
                        <Route path="math/multiplication" element={<MultiplicationPage />} />
                        <Route path="math/division" element={<DivisionPage />} />
                    </Routes>
                </Nav>
            </div>
        </div>
    );
}

export default App;
